import { IMAGES_URI_PREFIX, getCDN } from '@nordvpn/media-cdn';

type Optional<T> = T | undefined;

export const resolveSrc = (value?: string): Optional<string> =>
  value && value.indexOf(IMAGES_URI_PREFIX) === 0 ? `${getCDN()}${value}` : value;
